'use client';

import { useRouter } from 'next/navigation';

import { ErrorNotice } from '~/components';
import { useEnvironmentInfo } from '~/hooks';
import { closeWebviewOnApp } from '~/services/app-interface';

type Props = {
  error: CustomError & { digest?: string };
  reset: () => void;
};

export default function RootError({ error, reset }: Props) {
  const router = useRouter();
  const { isWebview } = useEnvironmentInfo();

  const notFoundStatus = error?.response?.status === 404;

  return (
    <ErrorNotice
      {...(notFoundStatus && { resetButtonText: '홈으로 이동' })}
      onResetClick={() => {
        if (isWebview) {
          notFoundStatus ? closeWebviewOnApp().go() : reset();

          return;
        }

        notFoundStatus ? router.replace('/') : reset();
      }}
    />
  );
}
